import React from 'react';
import { Link } from 'react-router-dom';

interface NotificationLinkProps {
  url: string | null | undefined;
  children: React.ReactNode;
  onClick?: () => void;
}

const NotificationLink: React.FC<NotificationLinkProps> = ({
  url,
  children,
  onClick: handleClick,
}) => {
  if (!url) {
    return children;
  }
  const urlIsPath = url.startsWith('/');
  const path = urlIsPath ? url : url.split('tienda.pari.mx')[1];

  if (!path) {
    return (
      <a href={url} target="_blank" rel="noreferrer" onClick={handleClick}>
        {children}
      </a>
    );
  }

  return (
    <Link to={path} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default NotificationLink;
